import EmailOutlined from '@mui/icons-material/EmailOutlined';

import { AppButton } from '@/components/atoms';

import { useServiceInquiry } from '../hooks/useServiceInquiry';

type Props = {
  serviceTitle?: string;
};

/** Reusable email route for service questions, using the shared info inbox. */
export function ServiceInquiryButton({ serviceTitle }: Props) {
  const inquiry = useServiceInquiry(serviceTitle);

  return (
    <AppButton
      href={inquiry.href}
      appVariant="secondary"
      fullWidth
      startIcon={<EmailOutlined aria-hidden />}
    >
      {inquiry.label}
    </AppButton>
  );
}
